import { render, staticRenderFns } from "./SubscriptionEnglish.vue?vue&type=template&id=20780141&"
import script from "./SubscriptionEnglish.vue?vue&type=script&lang=js&"
export * from "./SubscriptionEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports